import { ApiLoginResponse } from '@/ducks/auth/auth.types'

export const mapLoginResponse = (data: ApiLoginResponse) => ({
  token: data.token,
  id: data.store_id,
  type: data.store_type,
  storeName: data.store_name,
  currencyCode: data.currency_code,
  currencySymbol: data.currency_symbol,
  username: data.owner_name,
  avatar: data.store_avatar,
  availability: data.availability,
  usingCashCo: data.usingCashCo,
  phoneNumber: data.phone_number,
  phoneCode: data.country_code
})
